import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getWaybills as getWaybillsApi,
    getWaybillById as getWaybillByIdApi,
    createWaybill as createWaybillApi,
    retryWaybillApi,
} from "./api";
import { toast } from "react-toastify";

export const getWaybills = createAsyncThunk(
    "waybills/getWaybills",
    async (params?: {
        page?: number;
        limit?: number;
        search?: string;
        status?: string;
        issueDate?: string;
    }) => {
        try {
            const response: any = await getWaybillsApi(params);
            return response;
        } catch (error) {
            toast.error("Error al obtener las guías de remisión");
            throw error;
        }
    }
);

export const getWaybillById = createAsyncThunk(
    "waybills/getWaybillById",
    async (id: string) => {
        try {
            const response: any = await getWaybillByIdApi(id);
            return response;
        } catch (error) {
            toast.error("Error al obtener la guía de remisión");
            throw error;
        }
    }
);

export const createWaybill = createAsyncThunk(
    "waybills/createWaybill",
    async (data: any, { rejectWithValue }) => {
        try {
            const response: any = await createWaybillApi(data);

            // El backend de éxito esperado:
            // { success: true, message: "Comprobante recibido y en proceso de firma", data: {...} }
            if (response?.success) {
                toast.success(response?.message || "Guía de remisión creada exitosamente");
                return response;
            }

            // Si no es success, lo tratamos como error controlado
            // Algunos endpoints devuelven message como un JSON serializado con { code, status, message, error: [] }
            let normalized = response;
            if (response && typeof response.message === 'string') {
                try {
                    const inner = JSON.parse(response.message);
                    // Si tiene forma de validación, usamos ese objeto como payload de error
                    if (inner && (inner.error || inner.errors || inner.message)) {
                        normalized = inner;
                    }
                } catch (_) {
                    // no es JSON, lo dejamos tal cual
                }
            }

            const msg = normalized?.message || response?.message || "Error al crear la guía de remisión";
            toast.error(msg);
            return rejectWithValue(normalized);
        } catch (error: any) {
            const errData = error?.response?.data;
            // También puede venir como string JSON en errData.message
            let normalized = errData;
            if (errData && typeof errData.message === 'string') {
                try {
                    const inner = JSON.parse(errData.message);
                    if (inner && (inner.error || inner.errors || inner.message)) {
                        normalized = inner;
                    }
                } catch (_) {
                    // mantener original
                }
            }

            const msg = normalized?.message || error?.message || "Error al crear la guía de remisión";
            toast.error(msg);
            return rejectWithValue(normalized || { message: msg });
        }
    }
);

export const retryWaybill = createAsyncThunk(
    "waybills/retryWaybill",
    async (data: { progressJobId: string; progressStatus: string }, { rejectWithValue }) => {
        try {
            const response: any = await retryWaybillApi(data);

            if (response?.success) {
                toast.success(response.message || "Guía de remisión reencolada exitosamente");
                return response;
            }

            toast.error(response?.message || "Error al reintentar la guía de remisión");
            return rejectWithValue(response);
        } catch (error: any) {
            toast.error(error?.response?.data?.message || "Error al reintentar la guía de remisión");
            return rejectWithValue(error.response?.data);
        }
    }
);
